import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-4 container-fluid" }
const _hoisted_2 = { class: "row gx-4" }
const _hoisted_3 = { class: "col-lg-4" }
const _hoisted_4 = {
  class: "accordion",
  id: "accordionPanelsStayOpenExample"
}
const _hoisted_5 = {
  class: "accordion-header",
  id: "panelsStayOpen-headingOne"
}
const _hoisted_6 = ["data-bs-target"]
const _hoisted_7 = { class: "timeline-step p-3" }
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "accordion-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timeline_item = _resolveComponent("timeline-item")!
  const _component_timeline_list = _resolveComponent("timeline-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rotasFiltradas, (rota) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_timeline_list, {
              title: rota.name,
              rota: rota
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rota.Pedidos, (pedido, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(`accordion-item ${_ctx.getClassByStatus(pedido.status_entrega)}`),
                    key: index
                  }, [
                    _createElementVNode("h2", _hoisted_5, [
                      _createElementVNode("span", {
                        class: "acordion-pedido",
                        type: "button",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": `#panelsStayOpen-collapse${index}`,
                        "aria-expanded": "true",
                        "aria-controls": "panelsStayOpen-collapseOne"
                      }, [
                        _createElementVNode("span", _hoisted_7, [
                          _createElementVNode("i", {
                            class: _normalizeClass(`text-${_ctx.getColorByStatus(pedido.status_entrega)} text-gradient ${_ctx.getIconeByStatus(pedido.status_entrega)} `)
                          }, null, 2)
                        ]),
                        _createElementVNode("span", null, " Pedido " + _toDisplayString(pedido.numero_pedido), 1)
                      ], 8, _hoisted_6)
                    ]),
                    _createElementVNode("div", {
                      id: `panelsStayOpen-collapse${index}`,
                      class: _normalizeClass(`accordion-collapse collapse ${_ctx.getColorByStatus(pedido.status_entrega)!=='success'?'show':''}`),
                      "aria-labelledby": "panelsStayOpen-headingOne"
                    }, [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_timeline_item, {
                          class: _normalizeClass(_ctx.getClassByStatus(pedido.status_entrega)),
                          pedido: pedido,
                          icon: { component:  _ctx.getIconeByStatus(pedido.status_entrega), color: _ctx.getColorByStatus(pedido.status_entrega) },
                          title: `Pedido ${pedido.numero_pedido}`,
                          description: "``",
                          badges: []
                        }, null, 8, ["class", "pedido", "icon", "title"])
                      ])
                    ], 10, _hoisted_8)
                  ], 2))
                }), 128))
              ]),
              _: 2
            }, 1032, ["title", "rota"])
          ])
        ]))
      }), 256))
    ])
  ]))
}